import PostApi from '@/postApi';
export default {
	namespaced: true,
	state: {
	},
	actions: {
		async getPage({
			commit
		},param) {
			let getPage = await PostApi.getPage(param);
			getPage = getPage ? getPage.data : null;
			console.log('store pageDetail：', commit, param);
			return getPage;
		},
	},
	mutations: {
	},
}
